
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-04-09-react-scroll-parallex",
      function () {
        return require("private-next-pages/blogs/2023-04-09-react-scroll-parallex/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-04-09-react-scroll-parallex"])
      });
    }
  